import React, { useContext } from 'react';
import { RicosContext, EditorContext, PluginsEventsContext, ModalContext } from 'ricos-context';
import { EMOJI_TYPE } from 'wix-rich-content-common';
import EmojiPreviewModal from '../toolbar/emojiPreviewModal.js';
import { emojiModals } from '../types.js';
import 'prop-types';
import 'react-custom-scrollbars';
import 'wix-rich-content-ui-components';
import '../constants.js';
import '../icons/FaBell.js';
import '../icons/FaFlag.js';
import '../icons/FaHeart.js';
import '../icons/FaPaw.js';
import '../icons/FaPlane.js';
import '../icons/FaRegFutbol.js';
import '../icons/FaSmile.js';
import '../icons/FaUtensils.js';
import '../dataHooks.js';
import '../icons/JoyPixelsIcon.js';
import '../utils/getGroupEmojis.js';
import '../utils/convertUnicodeToEmoji.js';
import '../utils/emojiList.js';

const EmojiInsertModal = ({ showCloseButton }) => {
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const modalService = useContext(ModalContext) || {};
  const closeModal = () => {
    modalService == null ? void 0 : modalService.closeModal(emojiModals.insert);
  };
  const onEmojiAdd = (emoji) => {
    var _a;
    (_a = getEditorCommands()) == null ? void 0 : _a.insertText(emoji);
    pluginsEvents.publishPluginAddSuccess({ pluginId: EMOJI_TYPE, params: { emoji } });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(
    EmojiPreviewModal,
    {
      onAdd: onEmojiAdd,
      t,
      showCloseButton,
      closeModal
    }
  );
};

export { EmojiInsertModal as default };
//# sourceMappingURL=InsertModal.js.map
